// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainSection_mainContainer__ljLQA","filtersContainer":"mainSection_filtersContainer__vCBK2"};